import type { AbgSxProps } from '@abg/typings';

export const bannerContainerStyles: AbgSxProps = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '16px',
  gap: '16px',
  backgroundColor: '#000000',
  border: '1px solid rgba(115, 109, 109, 0.3)',
  borderRadius: '4px',
  position: 'relative',
  overflow: 'hidden',
  cursor: 'pointer',
  width: '100%',
  boxSizing: 'border-box',
};

export const redAccentLineStyles: AbgSxProps = {
  position: 'absolute',
  left: 0,
  top: 0,
  bottom: 0,
  width: '4px',
  backgroundColor: '#D4002A',
  borderRadius: '4px 0 0 4px',
};

export const contentStyles: AbgSxProps = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '16px',
  flexGrow: 1,
  minWidth: 0,
  paddingLeft: '4px',
};

export const logoStyles: AbgSxProps = {
  width: { xs: '86px', md: '100px' },
  height: { xs: '12px', md: '14px' },
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
};

export const descriptionStyles: AbgSxProps = {
  color: '#FFFFFF',
  fontSize: { xs: '14px', md: '16px' },
  lineHeight: '24px',
  letterSpacing: '0.003em',
  flexGrow: 1,
};

export const arrowIconStyles: AbgSxProps = {
  color: '#FFFFFF',
  width: '24px',
  height: '24px',
  flexShrink: 0,
};
